import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Phone as PhoneIcon, Send as SendIcon } from "@mui/icons-material";
import { ColorsConstants } from "../cssUtils/constants"; 

export default function PhoneMockup({
  botName,
  botLogo,
  children,
  subtitle = "RCS Business Message",
  placeholder = "RCS message...",
  color,
  width = 300,
  height = 580,
}) {
  const primaryColor = color || ColorsConstants.primaryBlue100 || "#1976d2";

  return (
    <Box sx={{ width, mx: "auto", background: "linear-gradient(160deg, #2a2a3e 0%, #1a1a2e 100%)", borderRadius: "44px", p: "10px", boxShadow: "0 0 0 1px #3a3a5c, 0 0 0 3px #1a1a2e, 0 24px 64px rgba(0,0,0,0.45)", position: "relative", userSelect: "none" }}>
      {/* Screen bezel */}
      <Box sx={{ background: "#e9ede8", borderRadius: "34px", overflow: "hidden", height, display: "flex", flexDirection: "column" }}>
        
        {/* ── Status Bar & Chat Header (BLUE) ── */}
        <Box sx={{ background: primaryColor, px: 2, pt: 1, pb: 0.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ color: "#fff", fontSize: "10px", fontWeight: 700 }}>9:41</Typography>
          <Typography sx={{ fontSize: "10px", color: "#fff" }}>WiFi 🔋</Typography>
        </Box>
        <Box sx={{ background: primaryColor, px: 1.5, py: 1, display: "flex", alignItems: "center", gap: 1, boxShadow: "0 2px 6px rgba(0,0,0,0.25)", zIndex: 2 }}>
          <Box sx={{ width: 34, height: 34, borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
            {botLogo ? <Box component="img" src={botLogo} sx={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: "14px" }}>{botName?.[0]?.toUpperCase() || "B"}</Typography>}
          </Box>
          <Box sx={{ flex: 1, overflow: "hidden" }}>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{botName || "Bot Name"}</Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "10px" }}>{subtitle}</Typography>
          </Box>
          <PhoneIcon sx={{ color: "rgba(255,255,255,0.85)", fontSize: 16 }} />
        </Box>

        {/* ── Chat Canvas ── */}
        <Box sx={{ flex: 1, overflowY: "auto", px: 1, py: 1.5, display: "flex", flexDirection: "column", gap: 1, backgroundColor: "#f4f4f6" }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 0.5 }}>
            <Box sx={{ bgcolor: "rgba(0,0,0,0.08)", borderRadius: "10px", px: 1.5, py: 0.25 }}><Typography sx={{ color: "#666", fontSize: "9px", fontWeight: 500 }}>TODAY</Typography></Box>
          </Box>
          
          {/* This is where the template components inject dynamically! */}
          {children} 
          
        </Box>

        {/* ── Bottom Input Bar ── */}
        <Box sx={{ bgcolor: "#fff", px: 1, py: 0.75, display: "flex", alignItems: "center", gap: 0.75 }}>
          <Box sx={{ flex: 1, bgcolor: "#f0f0f2", borderRadius: "20px", px: 1.5, py: 0.75 }}><Typography sx={{ color: "#aaa", fontSize: "10px" }}>{placeholder}</Typography></Box>
          <Box sx={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: primaryColor, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <SendIcon sx={{ color: "#fff", fontSize: 12, ml: "2px" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}